import React from 'react';
import { Link } from 'react-router-dom';

import './NavigationBar.css'



export default function NabigationBar({ applicationModal, applicationModalOpened, menuModal, menuModalOpened, modalUnderlayer, modalUnderlayerOpened }) {

    const openOrcloseApplicationModal = () => {

        const applicationModalAnimation = document.getElementById('Application-Modal')
        const navigationBarApplicationModalButtonColor = document.getElementById('NavigationBar-ApplicationModal-Button')
        const navigationBarApplicationModalButtonPTag = document.getElementById('NavigationBar-ApplicationModal-Button-P-Tag')

        const menuModalAnimation = document.getElementById('Menu-Modal')
        const navigationBarMenuModalButtonColor = document.getElementById('NavigationBar-MenuModal-Button')
        const navigationBarMenuModalButtonPTag = document.getElementById('NavigationBar-MenuModal-Button-P-Tag')

        const modalUnderLayerAnimation = document.getElementById('Modal-Underlayer')

        if (navigationBarApplicationModalButtonPTag.textContent === 'Open Apps' && navigationBarMenuModalButtonPTag.textContent === 'Open Menu') {
            navigationBarApplicationModalButtonPTag.textContent = 'Close Apps'
            navigationBarApplicationModalButtonColor.className = 'NavigationBar-ModalButton-Color-Opened NavigationBar-Buttons-Dimensions'
            applicationModalOpened(!applicationModal)
            modalUnderlayerOpened(!modalUnderlayer)
        } else {
            if (navigationBarApplicationModalButtonPTag.textContent === 'Open Apps' && navigationBarMenuModalButtonPTag.textContent === 'Close Menu') {
                navigationBarApplicationModalButtonPTag.textContent = 'Close Apps'
                navigationBarApplicationModalButtonColor.className = 'NavigationBar-ModalButton-Color-Closed NavigationBar-Buttons-Dimensions'
                navigationBarMenuModalButtonPTag.textContent = 'Open Menu'
                applicationModalOpened(!applicationModal)

                menuModalAnimation.className = 'Modal-Colors MenuModal-Animation-Closed MenuModal-Position MenuModal-Position MenuModal-Shape MenuModal-Dimensions'
                navigationBarMenuModalButtonColor.className = 'NavigationBar-ModalButton-Color-Closed NavigationBar-Buttons-Dimensions'
                navigationBarMenuModalButtonPTag.textContent = 'Open Menu'
                setTimeout(() => {
                    menuModalOpened(!menuModal)
                }, 285)
            } else {
                if (navigationBarApplicationModalButtonPTag.textContent === 'Close Apps' && navigationBarMenuModalButtonPTag.textContent === 'Open Menu') {
                    modalUnderLayerAnimation.className = 'ModalUnderlayer-Colors-Closed ModalUnderlayer-Position ModalUnderlayer-Dimensions'

                    applicationModalAnimation.className = 'Modal-Colors ApplicationModal-Animation-Closed ApplicationModal-Dimensions ApplicationModal-Position ApplicationModal-Shape'
                    navigationBarApplicationModalButtonColor.className = 'NavigationBar-ModalButton-Color-Closed NavigationBar-Buttons-Dimensions'
                    navigationBarApplicationModalButtonPTag.textContent = 'Open Apps'
                    setTimeout(() => {
                        applicationModalOpened(!applicationModal)
                        modalUnderlayerOpened(!modalUnderlayer)
                    }, 285);
                }
            }
        }
    };

    const openOrCloseMenuModal = () => {

        const applicationModalAnimation = document.getElementById('Application-Modal')
        const navigationBarApplicationModalButtonColor = document.getElementById('NavigationBar-ApplicationModal-Button')
        const navigationBarApplicationModalButtonPTag = document.getElementById('NavigationBar-ApplicationModal-Button-P-Tag')

        const menuModalAnimation = document.getElementById('Menu-Modal')
        const navigationBarMenuModalButtonColor = document.getElementById('NavigationBar-MenuModal-Button')
        const navigationBarMenuModalButtonPTag = document.getElementById('NavigationBar-MenuModal-Button-P-Tag')

        const modalUnderLayerAnimation = document.getElementById('Modal-Underlayer')

        if (navigationBarApplicationModalButtonPTag.textContent === 'Open Apps' && navigationBarMenuModalButtonPTag.textContent === 'Open Menu') {
            navigationBarMenuModalButtonPTag.textContent = 'Close Menu'
            navigationBarMenuModalButtonColor.className = 'NavigationBar-ModalButton-Color-Opened NavigationBar-Buttons-Dimensions'
            menuModalOpened(!menuModal)
            modalUnderlayerOpened(!modalUnderlayer)
        } else {
            if (navigationBarApplicationModalButtonPTag.textContent === 'Open Apps' && navigationBarMenuModalButtonPTag.textContent === 'Close Menu') {
                modalUnderLayerAnimation.className = 'ModalUnderlayer-Colors-Closed ModalUnderlayer-Position ModalUnderlayer-Dimensions'

                menuModalAnimation.className = 'Modal-Colors MenuModal-Animation-Closed MenuModal-Position MenuModal-Position MenuModal-Shape MenuModal-Dimensions'
                navigationBarMenuModalButtonColor.className = 'NavigationBar-ModalButton-Color-Closed NavigationBar-Buttons-Dimensions'
                navigationBarMenuModalButtonPTag.textContent = 'Open Menu'
                setTimeout(() => {
                    menuModalOpened(!menuModal)
                    modalUnderlayerOpened(!modalUnderlayer)
                }, 285)

            } else {
                if (navigationBarApplicationModalButtonPTag.textContent === 'Close Apps' && navigationBarMenuModalButtonPTag.textContent === 'Open Menu') {
                    navigationBarMenuModalButtonPTag.textContent = 'Close Menu'
                    navigationBarMenuModalButtonColor.className = 'NavigationBar-ModalButton-Color-Opened NavigationBar-Buttons-Dimensions'
                    navigationBarApplicationModalButtonPTag.textContent = 'Open Apps'
                    menuModalOpened(!menuModal)

                    applicationModalAnimation.className = 'Modal-Colors ApplicationModal-Animation-Closed ApplicationModal-Dimensions ApplicationModal-Position ApplicationModal-Shape'
                    navigationBarApplicationModalButtonColor.className = 'NavigationBar-ModalButton-Color-Closed NavigationBar-Buttons-Dimensions'
                    navigationBarApplicationModalButtonPTag.textContent = 'Open Apps'
                    setTimeout(() => {
                        applicationModalOpened(!applicationModal)
                    }, 285)
                }
            }
        }
    };

    const closeAllModals = () => {

        const navigationBarApplicationModalButtonPTag = document.getElementById('NavigationBar-ApplicationModal-Button-P-Tag')
        const navigationBarMenuModalButtonPTag = document.getElementById('NavigationBar-MenuModal-Button-P-Tag')

        if (navigationBarApplicationModalButtonPTag.textContent === 'Close Apps') {
            openOrcloseApplicationModal()
        }

        if (navigationBarMenuModalButtonPTag.textContent === 'Close Menu') {
            openOrCloseMenuModal()
        }
    }

    return (
        <section id='Navigation-Bar' className="NavigationBar-Colors NavigationBar-Position NavigationBar-Flex NavigationBar-Spacing NavigationBar-Dimensions">

            <Link id="NavigationBar-HomeButton" to='/'>
                <button onClick={closeAllModals} className="NavigationBar-HomeButton-Color NavigationBar-Buttons-Dimensions">
                    <p className='navigationButtons-font'>Home</p>
                </button>
            </Link>

            {applicationModal ? (
                <button onClick={openOrcloseApplicationModal} id='NavigationBar-ApplicationModal-Button' className="NavigationBar-ModalButton-Color-Opened NavigationBar-Buttons-Dimensions">
                    <p id="NavigationBar-ApplicationModal-Button-P-Tag">Close Apps</p>
                </button>
            ) : (
                <button onClick={openOrcloseApplicationModal} id='NavigationBar-ApplicationModal-Button' className="NavigationBar-ModalButton-Color-Closed NavigationBar-Buttons-Dimensions">
                    <p id="NavigationBar-ApplicationModal-Button-P-Tag">Open Apps</p>
                </button>
            )}

            {menuModal ? (
                <button onClick={openOrCloseMenuModal} id='NavigationBar-MenuModal-Button' className="NavigationBar-ModalButton-Color-Opened NavigationBar-Buttons-Dimensions">
                    <p id="NavigationBar-MenuModal-Button-P-Tag">Close Menu</p>
                </button>
            ) : (
                <button onClick={openOrCloseMenuModal} id='NavigationBar-MenuModal-Button' className="NavigationBar-ModalButton-Color-Closed NavigationBar-Buttons-Dimensions">
                    <p id="NavigationBar-MenuModal-Button-P-Tag">Open Menu</p>
                </button>
            )}

        </section>
    )
}